import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/upgrade.svg'


const _hoisted_1 = {
  key: 0,
  ref: "modal-backdrop",
  class: "fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-50"
}
const _hoisted_2 = { class: "flex items-start justify-center min-h-screen pt-24 text-center" }
const _hoisted_3 = {
  class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl p-5 w-1/3",
  role: "dialog",
  ref: "modal",
  "aria-modal": "true",
  "aria-labelledby": "modal-headline"
}
const _hoisted_4 = { class: "flex flex-col justify-center items-center w-full mt-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mb-6"
}, null, -1)
const _hoisted_6 = { class: "text-gray-500 text-justify" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Are you sure you want to continue ")
const _hoisted_8 = { class: "flex flex-row justify-between w-full mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200 transform",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-200 transform",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-300 transform ",
                  "enter-from-class": "opacity-0 translate-y-10 scale-95",
                  "enter-to-class": "opacity-100 translate-y-0 scale-100",
                  "leave-active-class": "ease-in duration-200",
                  "leave-from-class": "opacity-100 translate-y-0 scale-100",
                  "leave-to-class": "opacity-0 translate-y-10 translate-y-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "title"),
                        _renderSlot(_ctx.$slots, "thumbnail", {}, () => [
                          _hoisted_5
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "alert-text", {}, () => [
                          _hoisted_7
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "actions", {}, () => [
                          _createElementVNode("button", {
                            class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('confirmation', true)), ["prevent"]))
                          }, " Confirm "),
                          _createElementVNode("button", {
                            class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('confirmation', false)), ["prevent"]))
                          }, " decline ")
                        ])
                      ])
                    ], 512), [
                      [_vShow, _ctx.visible]
                    ])
                  ]),
                  _: 3
                })
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}